<template>
  <div class="main-content">
    <!-- 条件查询 -->
    <div>
      <el-form ref="searchForm" :inline="true" :model="searchForm" class="form-content">
        <el-row :gutter="20" :style="{justifyContent:contents.searchBoxPosition=='1'?'flex-start':contents.searchBoxPosition=='2'?'center':'flex-end'}"
                class="slt">

          <!--                    <el-form-item label="类型" prop="matchType">
                                  <el-select prefix-icon="el-icon-search" v-model="searchForm.matchType" placeholder="请选择配煤类型" clearable @change="getDataList">
                                      <el-option></el-option>
                                      <el-option label="自建库配煤" value="自建库配煤"></el-option>
                                      <el-option label="系统配煤" value="系统配煤"></el-option>
                                  </el-select>
                              </el-form-item>-->
          <el-form-item label="港口名称" prop="portName">
            <el-input v-model="searchForm.portName" clearable placeholder="请输入港口名称"
                      prefix-icon="el-icon-search"></el-input>
          </el-form-item>
          <el-form-item label="热值" prop="startHots">
            <el-input v-model="searchForm.startHots" clearable placeholder="起" prefix-icon="el-icon-search"
                      style="width:100px;padding-right:5px"></el-input>
            到
            <el-input v-model="searchForm.endHots" clearable placeholder="至" prefix-icon="el-icon-search"
                      style="width:100px"></el-input>
          </el-form-item>
          <el-form-item label="硫分" prop="startLiufen">
            <el-input v-model="searchForm.startLiufen" clearable placeholder="起" prefix-icon="el-icon-search"
                      style="width:100px;padding-right:5px"></el-input>
            到
            <el-input v-model="searchForm.endLiufen" clearable placeholder="至" prefix-icon="el-icon-search"
                      style="width:100px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="search()">查询<i class="el-icon-search el-icon--right"/></el-button>
            <el-button type="success" @click="reset()">重置<i class="el-icon-search el-icon--right"/></el-button>
          </el-form-item>
        </el-row>
        <el-row :style="{justifyContent:contents.btnAdAllBoxPosition=='1'?'flex-start':contents.btnAdAllBoxPosition=='2'?'center':'flex-end'}"
                class="slt">
          <el-form-item>
            <el-button v-show="isEmporer('新增')"
                       icon="el-icon-plus"
                       type="success"
                       @click="cocalSystemAdd()"
            >系统配煤
            </el-button>
            <el-button v-show="isEmporer('新增')"
                       hidden="hidden"
                       icon="el-icon-plus"
                       type="success"
                       @click="ownerAdd()"
            >自建库配煤
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="table-content">
        <el-table v-loading="dataListLoading" :border="contents.tableBorder" :cell-style="cellStyle"
                  :data="dataList" :fit="contents.tableFit"
                  :header-cell-style="headerCellStyle"
                  :header-row-style="headerRowStyle"
                  :row-style="rowStyle"
                  :show-header="contents.tableShowHeader"
                  :size="contents.tableSize"
                  :stripe="contents.tableStripe"
                  :style="{width: '100%',fontSize:contents.tableContentFontSize,color:contents.tableContentFontColor}"
                  class="tables"
                  @selection-change="selectionChangeHandler">
          <el-table-column v-if="contents.tableIndex" label="索引" type="index" width="50"/>

          <el-table-column align="center" header-align="center" label="类型" prop="matchType"></el-table-column>
          <el-table-column align="center" header-align="center" label="添加时间" prop="addTime">
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.addTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="添加人" prop="addUserName"></el-table-column>
          <el-table-column align="center" label="港口名称" prop="portName"></el-table-column>
          <el-table-column align="center" label="目标热值" prop="targetHots"></el-table-column>
          <el-table-column align="center" label="目标硫分" prop="targetLiufen"></el-table-column>
          <el-table-column align="center" label="目标吨数" prop="totalCount"></el-table-column>
          <el-table-column :align="contents.tableAlign" header-align="center"
                           label="操作"
                           width="300">
            <template slot-scope="scope">
              <el-button v-show="isEmporer('明细')" icon="el-icon-tickets" size="mini" type="success"
                         @click="openMatchList(scope.row)">详情
              </el-button>
              <el-button v-show="isEmporer('删除')" icon="el-icon-delete" size="mini" type="danger"
                         @click="deleteHandler(scope.row.id)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            :background="contents.pageBtnBG"
            :current-page="pageIndex"
            :layout="layouts"
            :page-size="Number(contents.pageEachNum)"
            :page-sizes="[10, 20, 50, 100]"
            :small="contents.pageStyle"
            :style="{textAlign:contents.pagePosition==1?'left':contents.pagePosition==2?'center':'right'}"
            :total="totalPage"
            class="pagination-content"
            clsss="pages"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
        ></el-pagination>
        <cocal-match-list :rowData="matchListRowData" :show="matchListShow"
                          v-on:listenToChildEvent="closeDialog"></cocal-match-list>
        <cocal-system-match-add :show="systemMatchShow"
                                v-on:listenToChildEvent="closeSystemMatchDialog"></cocal-system-match-add>
        <port-owner-match-add :show="ownerMatchShow"
                              v-on:listenToChildEvent="closeOwnerMatchDialog"></port-owner-match-add>
        <!--                <cocal-owner-match-add :show="ownerMatchShow" v-on:listenToChildEvent="closeOwnerMatchDialog"></cocal-owner-match-add>-->
      </div>
    </div>
  </div>
</template>
<script>
import styleJs from "../../../utils/style.js";
import cocalMatchList from './port-cocal-match-list';
import cocalSystemMatchAdd from './port-system-match-add';
import portOwnerMatchAdd from './port-owner-match-add';
// import cocalOwnerMatchAdd from './cocal-owner-match-add';
export default {
  data() {
    return {
      //打印结束
      searchForm: {
        key: "",
        matchType: '',
        portName: '',
        startHots: '',
        endHots: '',
        startLiufen: '',
        endLiufen: '',
      },
      sessionTable: "",//登录账户所在表名
      role: "",//权限
      userId: "",//当前登录人的id
      //级联表下拉框搜索条件
      //当前表下拉框搜索条件
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag: false,
      contents: null,
      layouts: '',
      rowData: {},
      matchListShow: false,
      matchListRowData: {},
      systemMatchShow: false,
      selectBtnStr: '',
      menuBtnList: [],
      ownerMatchShow: false,

    };
  },
  created() {
    this.contents = styleJs.listStyle();
    this.init();
    this.getDataList();
    let btnList = this.$storage.getMenuBtnListByMenuName("portMatchResult");
    this.selectBtnStr = btnList;
    this.initBtnList();
  },
  mounted() {
    //获取当前登录用户的信息
    this.sessionTable = this.$storage.get("sessionTable");
    this.role = this.$storage.get("role");
    this.userId = this.$storage.get("userId");

  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g, '');
    }
  },
  components: {
    cocalMatchList,
    cocalSystemMatchAdd,
    portOwnerMatchAdd
    // cocalOwnerMatchAdd
  },
  computed: {},
  methods: {

    // 表格
    rowStyle({row, rowIndex}) {
      if (rowIndex % 2 == 1) {
        if (this.contents.tableStripe) {
          return {color: this.contents.tableStripeFontColor}
        }
      } else {
        return ''
      }
    },
    cellStyle({row, rowIndex}) {
      if (rowIndex % 2 == 1) {
        if (this.contents.tableStripe) {
          return {backgroundColor: this.contents.tableStripeBgColor}
        }
      } else {
        return ''
      }
    },
    headerRowStyle({row, rowIndex}) {
      return {color: this.contents.tableHeaderFontColor}
    },
    headerCellStyle({row, rowIndex}) {
      return {backgroundColor: this.contents.tableHeaderBgColor}
    },
    // 表格按钮
    contentTableBtnStyleChange() {
    },
    // 分页
    contentPageStyleChange() {
      let arr = []
      if (this.contents.pageTotal) arr.push('total')
      if (this.contents.pageSizes) arr.push('sizes')
      if (this.contents.pagePrevNext) {
        arr.push('prev')
        if (this.contents.pagePager) arr.push('pager')
        arr.push('next')
      }
      if (this.contents.pageJumper) arr.push('jumper')
      this.layouts = arr.join()
      this.contents.pageEachNum = 10
    },

    init() {

    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'add_time',
        order: 'desc'
      }
      if (this.searchForm.matchType !== '' && this.searchForm.matchType !== undefined) {
        params['matchType'] = '%' + this.searchForm.matchType + '%'
      }
      if (this.searchForm.portName !== '' && this.searchForm.portName !== undefined) {
        params['portName'] = '%' + this.searchForm.portName + '%'
      }
      if (this.searchForm.startHots !== '' && this.searchForm.startHots !== undefined) {
        params['startHots'] = '' + this.searchForm.startHots + ''
      }
      if (this.searchForm.endHots !== '' && this.searchForm.endHots !== undefined) {
        params['endHots'] = '' + this.searchForm.endHots + ''
      }
      if (this.searchForm.startLiufen !== '' && this.searchForm.startLiufen !== undefined) {
        params['startLiufen'] = '' + this.searchForm.startLiufen + ''
      }
      if (this.searchForm.endLiufen !== '' && this.searchForm.endLiufen !== undefined) {
        params['endLiufen'] = '' + this.searchForm.endLiufen + ''
      }
      this.$http({
        url: "portMatchResult/page",
        method: "get",
        params: params
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });

      //查询级联表搜索条件所有列表
      //查询当前表搜索条件所有列表
    },
    //每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 删除
    deleteHandler(id) {
      var ids = id ? [Number(id)] : this.dataListSelections.map(item => {
        return Number(item.id);
      });

      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "portMatchResult/delete",
          method: "post",
          data: ids
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    formatDate(dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString();
    },
    closeDialog() {
      this.matchListShow = false;
      this.matchListRowData = {};
    },
    openMatchList(row) {
      this.matchListShow = true;
      this.matchListRowData = row;
    },
    closeSystemMatchDialog() {
      this.systemMatchShow = false;
      this.getDataList();
    },
    closeOwnerMatchDialog() {
      this.ownerMatchShow = false;
      this.getDataList();
    },
    //系统配煤打开方法
    cocalSystemAdd() {
      this.systemMatchShow = true;
    },
    //自建库配煤打开方法
    ownerAdd() {
      this.ownerMatchShow = true;
    },
    isEmporer(btnName) {
      let menuBtn = this.menuBtnList.find(item => item.indexName == btnName);
      return this.selectBtnStr.indexOf(menuBtn.codeIndex) == -1 ? false : true;
    },
    initBtnList() {
      let params = {
        page: this.pageIndex,
        limit: 30,
        sort: 'id',
      }
      //本表的
      params['dicCode'] = "menu_types"//编码名字
      params['dicName'] = "按钮类型",//汉字名字
          this.$http({
            url: "dictionary/page",
            method: "get",
            params: params
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.menuBtnList = data.data.list;
            }
          });
    },
    reset() {
      this.$refs['searchForm'].resetFields();
      this.startLiufen.endHots = '';
      this.startLiufen.endLiufen = '';

    }
  }
};
</script>
<style lang="scss" scoped>
    .main-content {
        background: #fff;
        border-radius: 6px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .slt {
        margin: 0 !important;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;
    }

    .ad {
        margin: 0 !important;
        display: flex;
        align-items: center;
        padding: 12px 0;
    }

    .pages {
        & /deep/ el-pagination__sizes {
            & /deep/ el-input__inner {
                height: 28px;
                line-height: 28px;
            }
        }
    }

    .el-button+.el-button {
        margin-left: 8px;
    }

    .form-content {
        background: transparent;
    }

    .table-content {
        background: transparent;
    }

    /* 搜索区按钮 */
    .form-content .slt .el-button--success {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #2b5797;
            border-color: #2b5797;
        }
    }

    /* 新增按钮 */
    .form-content .ad .el-button--success {
        background-color: var(--publicSubColor);
        border-color: var(--publicSubColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #c9602d;
            border-color: #c9602d;
        }
    }

    /* 表格样式 */
    .tables {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;

        & /deep/ .el-table__header th {
            background-color: #f5f7fa;
            color: #303133;
            font-weight: 600;
            font-size: 14px;
        }

        & /deep/ .el-table__body tr {
            background-color: #fff !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr.el-table__row--striped td {
            background: #fafafa;
        }

        & /deep/ .el-table__body tr.el-table__row--striped {
            background-color: #fafafa !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr:hover > td {
            background-color: rgba(58, 110, 165, 0.06) !important;
            color: #303133 !important;
        }

        /* 表格操作按钮 */
        & /deep/ .el-button--success {
            background-color: #67c23a;
            border-color: #67c23a;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #85ce61;
                border-color: #85ce61;
            }
        }

        & /deep/ .el-button--primary {
            background-color: var(--publicMainColor);
            border-color: var(--publicMainColor);
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #2b5797;
                border-color: #2b5797;
            }
        }

        & /deep/ .el-button--danger {
            background-color: #f56c6c;
            border-color: #f56c6c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #f78989;
                border-color: #f78989;
            }
        }

        & /deep/ .el-button--warning {
            background-color: #e6a23c;
            border-color: #e6a23c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #ebb563;
                border-color: #ebb563;
            }
        }

        & /deep/ .el-button {
            margin: 4px;
        }
    }

    /* 分页 */
    .pagination-content {
        margin-top: 20px;
        padding: 10px 0;
    }

    /* 封面图片 */
    .tables /deep/ img {
        border-radius: 6px;
        object-fit: cover;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
</style>


